import { IconButton as MuiIconButton, styled } from '@mui/material'

export const IconButton = styled(MuiIconButton)(({ theme }) => {
  return {
    translate: `0 ${theme.spacing(-1)}`,
  }
})
